import { Client } from '@/types'
import { LicenseStatus, LICENSE_STATUS_LABELS } from '@/types/license.types'

export function resolveLicenseStatus(client: Client): LicenseStatus {
  if (client.licenseStatus) return client.licenseStatus
  return client.isActive === false ? LicenseStatus.BLOCKED : LicenseStatus.VALID
}

export function getLicenseStatusLabel(client: Client): string {
  return LICENSE_STATUS_LABELS[resolveLicenseStatus(client)]
}

export function formatLicenseDate(value?: string): string {
  if (!value) return '—'
  return new Date(value).toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export function getLicenseStatusClasses(status: LicenseStatus): string {
  switch (status) {
    case LicenseStatus.VALID:
      return 'bg-[var(--color-success)]/10 text-[var(--color-success)]'
    case LicenseStatus.BLOCKED:
      return 'bg-[var(--color-warning)]/10 text-[var(--color-warning)]'
    case LicenseStatus.TERMINATED:
      return 'bg-[var(--color-gray-200)]/10 text-[var(--color-text-muted)]'
    default:
      return 'bg-[var(--color-gray-200)]/10 text-[var(--color-text-muted)]'
  }
}
